import { getTranslate } from 'legacy-src/utilities/i18n'
import React from 'react'

import { Button } from '../components/ui/button'

type Props = { sessionLength?: number; price: number }

const TherapistFreeSessionAd: React.FC<Props> = ({ sessionLength, price }) => {
  const { t } = getTranslate()

  const handleToSchedule = () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <div className="flex flex-col items-center pb-12 pt-16 text-center">
      <h3 className="h1 mb-6 max-w-[600px]">{t('therapistProfile.freeSessionBox.title')}</h3>
      <p className="mb-8 text-xl">{t('therapistProfile.freeSessionBox.text')}</p>
      <div className="card w-full max-w-[950px] bg-white">
        <div className="-mx-6 -my-4 flex flex-wrap items-center justify-between">
          <div className="margin-auto h2 mb-0 px-6 py-4 text-secondary">{t('general.firstSession')}</div>
          <div className="margin-auto flex items-center px-6 py-4">
            <div className="h3 mb-0 mr-6 text-text-color line-through">
              {t('general.currency', { currency: price })}
            </div>
            <div className="h1 mb-0 text-primary">{t('general.currency', { currency: 0 })}</div>
          </div>
          <div className="margin-auto description__time px-6 py-4 text-text-color">
            <strong>{t('component.discountModal.savingAppointments', { duration: sessionLength })}</strong>
          </div>
        </div>
      </div>
      <div className="mt-8">
        <Button onClick={handleToSchedule}> {t('therapistProfile.chooseAppointment')}</Button>
      </div>
    </div>
  )
}

export default TherapistFreeSessionAd
